import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminFounderApprovals = lazy(() => import("@/pages/admin/AdminFounderApprovals"));

export const Route = createFileRoute("/admin/founder-approvals")({
  component: AdminFounderApprovals,
});
